import HostConfig from '@/config/host-config'
import router from '../router'
import { saveAs } from 'file-saver'
import axios from 'axios'
import { Message } from 'element-ui'

/**
* @module common 公共函数库
* @author: changh 2018-04-18 16:50:11
* @param: {object}
* @return: object
*/
export default {
  // 统分时开启跳过功能使用
  debug_password: 'hytStone',
  bigdata_token: '?access_token=8f8059e6b283bd3e449e369c3b2c1e14',
  a4PaperSize_mm: {
    height: 297,
    width: 210
  },
  a3PaperSize_mm: {
    height: 297,
    width: 420
  },
  // 格式化日期时间
  // 对Date的扩展，将 Date 转化为指定格式的String
  // 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
  // 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
  // 例子：
  // (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
  // (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
  dateTimeFormat (date, fmt) {
    let d = new Date(date)
    let o = {
      'M+': d.getMonth() + 1, // 月份
      'd+': d.getDate(), // 日
      'h+': d.getHours(), // 小时
      'm+': d.getMinutes(), // 分
      's+': d.getSeconds(), // 秒
      'q+': Math.floor((d.getMonth() + 3) / 3), // 季度
      'S': d.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (d.getFullYear() + '').substr(4 - RegExp.$1.length))
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  },
  /** 根据教育机构类型值返回名称 如 传入12 返回 区教育局
    * @module common
    * @author: changh 2018-04-18 16:53:07
    * @param: {object}
    * @return: promise
    */
  translateOrgLevel (levelValue = '') {
    levelValue = levelValue.toString()
    switch (levelValue) {
      case '11':
        return '市教育局'
      case '12':
        return '小学、初中、高中' // 区教育局
      case '21':
        return '高中'
      case '22':
        return '初中'
      case '23':
        return '小学'
      case '24':
        return '小学、初中'
      case '25':
        return '初中、高中'
      case '26':
        return '幼儿园'
      case '27':
        return '小学、高中'
      case '28':
        return '小学、初中、高中'
      default:
        return ''
    }
  },
  GetSchoolLevelArray (schoolType = '') {
    let levels = []
    switch (schoolType) {
      case '21':
        levels = ['high']
        break
      case '22':
        levels = ['junior']
        break
      case '23':
        levels = ['primary']
        break
      case '24':
        levels = ['junior', 'primary']
        break
      case '25':
        levels = ['high', 'junior']
        break
      case '26':
        break
      case '27':
        levels = ['high', 'primary']
        break
      case '28':
        levels = ['high', 'junior', 'primary']
    }
    return levels
  },
  /** 根据教育机构类型值返回类型 如 传入12 返回 教育机构，21返回学校
    * @module common
    * @author: changh 2018-04-18 16:53:07
    * @param: {object}
    * @return: promise
    */
  translateOrgType (levelValue = '') {
    if (!levelValue) {
      return '其他'
    }
    levelValue = levelValue.toString()
    switch (levelValue) {
      case '11':
      case '12':
        return '教育管理机构'
      case '21':
      case '22':
      case '23':
      case '24':
      case '25':
      case '26':
      case '27':
      case '28':
        return '学校'
      default:
        return ''
    }
  },

  translateImageType (storageAddressCode = '') {
    storageAddressCode = storageAddressCode.toString()
    switch (storageAddressCode) {
      case '1':
        return '七牛云'
      case '2':
        return '阿里云'
      default:
        return '本地部署'
    }
  },
  // 根据学阶代码，返回学阶名称
  translateLevelType (levelKey = '') {
    switch (levelKey) {
      case 'high':
        return '高中'
      case 'junior':
        return '初中'
      case 'primary':
        return '小学'
      default:
        return ''
    }
  },
  gradeNames: ['小一', '小二', '小三', '小四', '小五', '小六', '初一', '初二', '初三', '高一', '高二', '高三'],
  // 根据gradeId，返回年级名称
  calcGradeName (gradeId) {
    let gradeName = ''
    try {
      gradeName = this.gradeNames[parseInt(gradeId) - 1]
    } catch (e) {
      console.log(e)
    }
    return gradeName
  },

  /**
   * 获取年级信息
   * @return {object} [年级信息]
   */
  getGradesInfo () {
    return [{
      gradeId: '10',
      gradeName: '高一',
      level: 'high'
    }, {
      gradeId: '11',
      gradeName: '高二',
      level: 'high'
    }, {
      gradeId: '12',
      gradeName: '高三',
      level: 'high'
    }, {
      gradeId: '7',
      gradeName: '初一',
      level: 'junior'
    }, {
      gradeId: '8',
      gradeName: '初二',
      level: 'junior'
    }, {
      gradeId: '9',
      gradeName: '初三',
      level: 'junior'
    }, {
      gradeId: '1',
      gradeName: '小一',
      level: 'primary'
    }, {
      gradeId: '2',
      gradeName: '小二',
      level: 'primary'
    }, {
      gradeId: '3',
      gradeName: '小三',
      level: 'primary'
    }, {
      gradeId: '4',
      gradeName: '小四',
      level: 'primary'
    }, {
      gradeId: '5',
      gradeName: '小五',
      level: 'primary'
    }, {
      gradeId: '6',
      gradeName: '小六',
      level: 'primary'
    }]
  },
  // 主观题的校验类型
  subjectCheckType: ['1', '3'],
  // 客观题的校验类型
  objectCheckType: ['2'],
  checkTypeMap: {
    '1': '主观题缺考有分',
    '2': '客观题缺考有串',
    '3': '按分数段核查'
  },
  /**
   * 获取用户信息
   * @return {object} [用户信息]  {userId: "", origanization: "", mobilePhone: ""}
   */
  getUserInfo () {
    if (sessionStorage.getItem('user_info')) {
      return JSON.parse(sessionStorage.getItem('user_info'))
    } else {
      // 兼容火狐评卷，sessionStorage问题
      return JSON.parse(localStorage.getItem('user_info'))
    }
  },

  /**
   * 重定向到考网主页
   */
  goHome () {
    // this.router.go(-1)
    router.push({ path: '/' })
  },
  /**
   * 获取考网token
   */
  getToken () {
    let searchUserId = location.search.split('userId=')[1] ? { userId: location.search.split('userId=')[1].split('&')[0] } : null
    let userInfo = JSON.parse(sessionStorage.getItem('user_info')) || searchUserId || (top.GLOBAL ? top.GLOBAL.user : null) || {}
    return localStorage.getItem(`kw_token-${userInfo.userId}`)
  },
  /**
             * 解析url参数
             * @Author   wangk
             * @DateTime 2016-08-17T17:42:16+0800
             * @param    {[type]} url [description]
             * @return   {[type]}     [description]
             */
  parseUrlParam (url) {
    let _index = url.indexOf('?')
    if (_index !== -1) {
      url = url.substr(_index + 1)
    }
    // 检测url是否使用了escape进行处理
    // escape返回字符的unicode值(如"%u4E0B"或"%20")
    let escapeReg = /(%u[a-zA-Z0-9]{4})|(%[a-zA-Z0-9]{2})/
    let escapeDeepth = 0 // 防止unescape进入死循环(最多执行5次)
    while (escapeDeepth++ < 5 && escapeReg.test(url)) {
      url = unescape(url)
    }
    let temp = url.split('&')
    let temp2
    let json = {}
    for (let i = 0; i < temp.length; i++) {
      temp2 = temp[i].split('=')
      let jsonValue = temp2[1]
      if ((jsonValue.charAt(0) === '{' && jsonValue.charAt(jsonValue.length - 1) === '}') ||
                      (jsonValue.charAt(0) === '[' && jsonValue.charAt(jsonValue.length - 1) === ']')) {
        jsonValue = JSON.parse(jsonValue)
      }
      json[temp2[0]] = jsonValue
    }
    return json
  },
  /* ==========================================================================
   * 【过渡期兼容逻辑 - 后续全面迁移新版后可整块删除】 START
   * ========================================================================== */
  /**
   * 判断是否属于老版图片服务（IMG旧版架构）
   * 动态特征识别：老版图片服务通常使用专属域名 img-cn-*，此类域名才支持 @ 管道符语法
   * @param {string} url 原图路径
   * @returns {boolean}
   */
  isLegacyImgService (url) {
    if (!url) return false
    // 标准阿里云 OSS 新版域名（包含 .oss-）必定只支持新版 x-oss-process
    if (url.includes('.oss-')) {
      return false
    }
    // 命中老版专属域名（如 imgal*.kaow.cn、*.img-cn-* 等）或非标准 OSS 地址走老版
    return true
  },

  /**
   * 构建老版子图 URL（@.jpg|pos|rotate|compress）
   * @param {Object} params 参数对象
   * @returns {string} 老版子图 URL
   */
  buildLegacySubImgUrl ({ imgOrigin, x1, y1, w, h, pivot, compressRatio }) {
    // 裁剪坐标格式: x-y-w-ha
    let pos = x1 + '-' + y1 + '-' + w + '-' + h + 'a'
    // 旋转角度
    let rotate = (360 - parseInt(pivot || 0, 10) * 90) + 'r'
    // 压缩率
    let compress = compressRatio + 'q'
    let imgFormat = '.jpg'
    return imgOrigin + '@' + imgFormat + '|' + pos + '|' + rotate + '|' + compress + this.bigdata_token + '&t=' + this.getTimeKey()
  },
  /* ==========================================================================
   * 【过渡期兼容逻辑 - 后续全面迁移新版后可整块删除】 END
   * ========================================================================== */

  parseImgUrl (url, optCompress) {
    // 最终返回值
    let returnAry = []

    // 默认压缩率(0 - 100)
    let defaultCompressRatio = 20
    let compressRatio = (typeof optCompress === 'undefined' || isNaN(parseInt(optCompress, 10)))
      ? defaultCompressRatio
      : parseInt(optCompress, 10)

    // url1#split#url2 ==> [url1, url2]
    let imgUrls = url.split('#split#')

    for (let i = 0; i < imgUrls.length; i++) {
      let imgOrigin = imgUrls[i].split('?')[0]
      let imgInfo = this.parseUrlParam(imgUrls[i])

      // 解析坐标 (返回的是左上角和右下角坐标: x1, y1, x2, y2)
      let posAry = (imgInfo.pos || '0,0,0,0').split(',')
      let x1 = parseInt(posAry[0], 10) || 0
      let y1 = parseInt(posAry[1], 10) || 0
      let x2 = parseInt(posAry[2], 10) || 0
      let y2 = parseInt(posAry[3], 10) || 0
      let w = Math.max(0, x2 - x1)
      let h = Math.max(0, y2 - y1)

      /* ==========================================================================
       * 【过渡期分流分支 - 后续全面迁移新版后仅需删除此 if 分支】 START
       * ========================================================================== */
      if (this.isLegacyImgService(imgOrigin)) {
        // 动态识别为老版服务时，走老版拼接通道
        returnAry.push(this.buildLegacySubImgUrl({
          imgOrigin,
          x1,
          y1,
          w,
          h,
          pivot: imgInfo.pivot,
          compressRatio
        }))
        continue
      }
      /* ==========================================================================
       * 【过渡期分流分支 - 后续全面迁移新版后仅需删除此 if 分支】 END
       * ========================================================================== */

      // ======================= 新版图片服务 (x-oss-process) =======================
      // 1. 顺时针旋转角度计算 (若为 0 或 360 度则无需拼接旋转参数，提升处理性能)
      let rotateDeg = (360 - parseInt(imgInfo.pivot || 0, 10) * 90) % 360
      let rotateParam = rotateDeg > 0 ? `/rotate,${rotateDeg}` : ''

      // 2. 拼接新版图片处理参数: 裁剪 -> 旋转 -> 压缩质量 -> 转jpg
      let processParam = `x-oss-process=image/crop,x_${x1},y_${y1},w_${w},h_${h}${rotateParam}/quality,q_${compressRatio}/format,jpg`

      // 3. 处理鉴权 token (去除前导问号并统一使用 & 拼接)
      let tokenPart = this.bigdata_token
        ? (this.bigdata_token.startsWith('?') ? this.bigdata_token.slice(1) : this.bigdata_token)
        : ''

      // 4. 组合最终标准子图 URL
      let finalUrl = `${imgOrigin}?${processParam}${tokenPart ? '&' + tokenPart : ''}&t=${this.getTimeKey()}`
      returnAry.push(finalUrl)
    }
    return returnAry
  },
  // 解析全图路径,带水印（使用新版图像API）
  parseFullImgUrlWithWaterImg (fullImageUrlArray, waterImgUrlArray) {
    // 最终返回值
    let returnAry = []

    // 配置参数: 转换后的图像格式
    // ".jpg": 阿里云图片服务参数, 指定转换后的图片格式
    // 参考文档: https://help.aliyun.com/document_detail/32244.html
    let imgForamt = 'x-oss-process=image/interlace,1/format,jpg'
    // 配置参数: 默认压缩率(0 - 100)
    // 参考文档: https://help.aliyun.com/document_detail/32243.html
    let defaultCompressRatio = 'quality,q_50'

    // url1#split#url2 ==> [url1, url2]

    let waterBaseImageUrl = 'blank.png'

    for (let i = 0; i < fullImageUrlArray.length; i++) {
      let imageUrl = fullImageUrlArray[i]
      let formatUrl = `${imageUrl}?${imgForamt}/${defaultCompressRatio}`
      if (waterImgUrlArray && waterImgUrlArray.length > 0) {
        let tmpArray = imageUrl.split('/')
        let imageFileName = tmpArray[tmpArray.length - 1]
        for (let waterInfo of waterImgUrlArray) {
          if (waterInfo.imageIndex.toString() === imageFileName.split('_')[1]) {
            let imageBase64 = window.btoa(`${waterBaseImageUrl}?x-oss-process=image/resize,m_fixed,h_${parseInt(waterInfo.position.h)},w_${parseInt(waterInfo.position.w)},limit_0`)
            formatUrl += `/watermark,image_${imageBase64},g_nw,x_${parseInt(waterInfo.position.x)},y_${parseInt(waterInfo.position.y)}`
          }
        }
      }
      returnAry.push(formatUrl)
    }
    return returnAry
  },
  // 解析全图路径 (支持新老版本动态识别)
  parseFullImgUrl (url, optCompress) {
    let returnAry = []
    let defaultCompressRatio = 20
    let compressRatio = (typeof optCompress === 'undefined' || isNaN(parseInt(optCompress, 10)))
      ? defaultCompressRatio
      : parseInt(optCompress, 10)

    let imgUrls = url.split('#split#')
    let fullImageUrlArray = []
    for (let i = 0; i < imgUrls.length; i++) {
      let fullImageUrl = imgUrls[i].split('?')[0]
      if (fullImageUrlArray.indexOf(fullImageUrl) === -1) {
        fullImageUrlArray.push(fullImageUrl)
      }
    }

    for (let i = 0; i < fullImageUrlArray.length; i++) {
      let imgOrigin = fullImageUrlArray[i]
      /* ==========================================================================
       * 【过渡期分流分支 - parseFullImgUrl 老版分支】 START
       * ========================================================================== */
      if (this.isLegacyImgService(imgOrigin)) {
        returnAry.push(imgOrigin + '@.jpg|0r|' + compressRatio + 'q')
        continue
      }
      /* ==========================================================================
       * 【过渡期分流分支 - parseFullImgUrl 老版分支】 END
       * ========================================================================== */
      returnAry.push(`${imgOrigin}?x-oss-process=image/quality,q_${compressRatio}/format,jpg`)
    }
    return returnAry
  },

  /**
   * 将图片转为 jpg 格式路径（支持新老版动态识别）
   * @param {string} url 原图路径
   * @returns {string} 转为 jpg 后的访问路径
   */
  parseImgToJpg (url) {
    if (!url) return ''
    /* ==========================================================================
     * 【过渡期分流分支 - parseImgToJpg 老版分支】 START
     * ========================================================================== */
    if (this.isLegacyImgService(url)) {
      return url + '@jpg' + this.bigdata_token
    }
    /* ==========================================================================
     * 【过渡期分流分支 - parseImgToJpg 老版分支】 END
     * ========================================================================== */
    let tokenPart = this.bigdata_token
      ? (this.bigdata_token.startsWith('?') ? this.bigdata_token.slice(1) : this.bigdata_token)
      : ''
    let delimiter = url.includes('?') ? '&' : '?'
    return `${url}${delimiter}x-oss-process=image/format,jpg${tokenPart ? '&' + tokenPart : ''}`
  },

  /**
   * 根据坐标获取子图路径（支持新老版动态识别）
   * @param {string} fullImagePath 原图完整路径
   * @param {Object} position 坐标信息 { x, y, w, h }
   * @param {number|string} rotate 旋转角度
   * @param {string} compress 压缩率，如 '30q' 或 30
   * @returns {string} 子图 URL
   */
  getSubImgPathByPosition (fullImagePath, position, rotate, compress = '30q') {
    if (!fullImagePath) return ''
    /* ==========================================================================
     * 【过渡期分流分支 - getSubImgPathByPosition 老版分支】 START
     * ========================================================================== */
    if (this.isLegacyImgService(fullImagePath)) {
      let pos = position.x + '-' + position.y + '-' + position.w + '-' + position.h + 'a'
      return fullImagePath + '@jpg|' + pos + '|' + rotate + '|' + compress + this.bigdata_token
    }
    /* ==========================================================================
     * 【过渡期分流分支 - getSubImgPathByPosition 老版分支】 END
     * ========================================================================== */

    // 新版处理逻辑
    let q = parseInt(compress, 10) || 30
    let deg = (parseInt(rotate || 0, 10) || 0) % 360
    let rotateParam = deg > 0 ? `/rotate,${deg}` : ''
    let processParam = `x-oss-process=image/crop,x_${position.x},y_${position.y},w_${position.w},h_${position.h}${rotateParam}/quality,q_${q}/format,jpg`
    let tokenPart = this.bigdata_token
      ? (this.bigdata_token.startsWith('?') ? this.bigdata_token.slice(1) : this.bigdata_token)
      : ''
    let delimiter = fullImagePath.includes('?') ? '&' : '?'
    return `${fullImagePath}${delimiter}${processParam}${tokenPart ? '&' + tokenPart : ''}`
  },
  parsePositionToPercent (positionInfo, paperType) {
    if (paperType === 'a3') {
      positionInfo.x1_percent = parseInt(positionInfo.x1) / this.a3PaperSize_mm.width
      positionInfo.y1_percent = parseInt(positionInfo.y1) / this.a3PaperSize_mm.height
      positionInfo.x2_percent = parseInt(positionInfo.x2) / this.a3PaperSize_mm.width
      positionInfo.y2_percent = parseInt(positionInfo.y2) / this.a3PaperSize_mm.height
    } else {
      positionInfo.x1_percent = parseInt(positionInfo.x1) / this.a4PaperSize_mm.width
      positionInfo.y1_percent = parseInt(positionInfo.y1) / this.a4PaperSize_mm.height
      positionInfo.x2_percent = parseInt(positionInfo.x2) / this.a4PaperSize_mm.width
      positionInfo.y2_percent = parseInt(positionInfo.y2) / this.a4PaperSize_mm.height
    }
  },
  getUserInfoSourceRole () {
    let kwInfoKeys = [1, 2, 5]
    let userInfoSource = this.getUserInfo().infoSources
    if (kwInfoKeys.indexOf(userInfoSource) > -1) {
      return true
    } else {
      return false
    }
  },
  /**
   * 获取一个跟当前时间相关的不重复的数字,当你需要一个不重复的字符串时可以用它
   * @author changh 2018-02-18T10:25:12+0800
   * @return {string} timeKey
   */
  getTimeKey () {
    let d = new Date()
    return d.getTime() + Math.random() * 10000000000000000
  },
  translateNum (num) {
    switch (num) {
      case 1:
        return '一'
      case 2:
        return '二'
      case 3:
        return '三'
      case 4:
        return '四'
      case 5:
        return '五'
      case 6:
        return '六'
      case 7:
        return '七'
      case 8:
        return '八'
      case 9:
        return '九'
      case 10:
        return '十'
      default:
        return ''
    }
  },
  convertNumToLetter (num) {
    switch (parseInt(num)) {
      case 0:
        return 'A'
      case 1:
        return 'B'
      case 2:
        return 'C'
      case 3:
        return 'D'
      case 4:
        return 'E'
      case 5:
        return 'F'
      case 6:
        return 'G'
      case 7:
        return 'H'
      case 8:
        return 'I'
      case 9:
        return 'J'
      default:
        return ''
    }
  },
  // 根据角色ID获取菜单
  getUserMenusByRoleId (roldId) {
    let userMenus = new Map()
    // 运维
    userMenus.set(this.systemRoleEnum.admin, [
      // {
      //   menuId: '1001',
      //   menuText: '首页',
      //   iconClassName: 'iconfont icon-shouye',
      //   url: '/',
      //   target: '',
      //   children: []
      // },
      {
        menuId: '1002',
        menuText: '客户管理',
        iconClassName: 'iconfont icon-kehu',
        url: '/customer',
        target: '',
        children: []
      }, {
        menuId: '1009',
        menuText: '财务对账',
        iconClassName: 'iconfont icon-laoshi',
        url: '/finance',
        target: '',
        children: []
      }, {
        menuId: '1010',
        menuText: '销售管理',
        iconClassName: 'iconfont icon-kehuguanli',
        url: '/sale',
        target: '',
        children: []
      }, {
        menuId: '1003',
        menuText: '监控',
        iconClassName: 'iconfont icon-xitongjiankong',
        url: '/admin/exam-list-unrelease',
        target: '',
        children: []
      }, {
        menuId: '1004',
        menuText: '基础信息',
        iconClassName: 'iconfont icon-jichuxinxi1',
        url: '',
        target: '',
        children: [
          {
            Pid: '1004',
            menuId: '10041',
            menuText: '课程科目',
            iconClassName: 'iconfont icon-xuexiao_kemu',
            url: `/admin/subject/class`,
            target: '',
            children: []
          },
          {
            Pid: '1004',
            menuId: '10042',
            menuText: '考试科目',
            iconClassName: 'iconfont icon-kaoshi',
            url: '/admin/subject/exam',
            target: '',
            children: []
          },
          {
            Pid: '1004',
            menuId: '10043',
            menuText: '行政区域',
            iconClassName: 'iconfont icon-biaoji',
            url: '',
            target: '',
            children: []
          },
          {
            Pid: '1004',
            menuId: '10044',
            menuText: '基础角色',
            iconClassName: 'iconfont icon-kehuguanli',
            url: '/admin/role/manager',
            target: '',
            children: []
          }
        ]
      }, {
        menuId: '1005',
        menuText: '代理商',
        iconClassName: 'iconfont icon-dailishang',
        url: '/admin/agent/list',
        target: '',
        children: []
      }, {
        menuId: '1006',
        menuText: '授权码',
        iconClassName: 'iconfont icon-tongjifenxi-copy',
        url: '/admin/getTempAuthorizeCode',
        target: '',
        children: []
      }, {
        menuId: '1007',
        menuText: '数据同步',
        iconClassName: 'iconfont icon-data',
        url: '/admin/sync',
        target: '',
        children: []
      }, {
        menuId: '1008',
        menuText: '操作日志',
        iconClassName: 'iconfont icon-yunweirenyuan',
        url: '/admin/behavior-record',
        target: '',
        children: []
      }])
    // 教育局信息管理员
    userMenus.set(this.systemRoleEnum.eduInfoManager, [{
      menuId: '2001',
      menuText: '考试',
      iconClassName: 'iconfont icon-kaoshi',
      url: '/',
      target: '',
      children: []
    },
    {
      menuId: '2002',
      menuText: '成绩',
      iconClassName: 'iconfont icon-chengji',
      url: `/score/list/${this.getUserInfo().origanization}`,
      target: '',
      children: []
    },
    {
      menuId: '2004',
      menuText: '用户',
      iconClassName: 'iconfont icon-kehuguanli',
      url: `/org/${this.getUserInfo().origanization}/member-info`,
      target: '',
      children: []
    },
    {
      menuId: '2003',
      menuText: '基础信息',
      iconClassName: 'iconfont icon-jichuxinxi1',
      url: `/org/${this.getUserInfo().origanization}`,
      target: '',
      children: []
    }])
    // 教育局教研员
    userMenus.set(this.systemRoleEnum.researcher, [{
      menuId: '3001',
      menuText: '考试',
      iconClassName: 'iconfont icon-kaoshi',
      url: '/',
      target: '',
      children: []
    },
    {
      menuId: '3002',
      menuText: '成绩',
      iconClassName: 'iconfont icon-chengji',
      url: `/score/list/${this.getUserInfo().origanization}`,
      target: '',
      children: []
    }])

    let schoolPaperCardMenu = {
      menuId: '4004',
      menuText: '题卡制作',
      iconClassName: 'el-icon-edit-outline',
      url: '',
      target: '',
      children: [
        {
          Pid: '4004',
          menuId: '40043',
          menuText: '在线题卡',
          iconClassName: 'iconfont icon-datiqia1',
          url: '/card/list',
          target: '',
          children: []
        }
      ]
    }
    if (['1515633109674',
      '1483959046265',
      '1483959048499',
      '1483959049637',
      '1483959047770',
      '1576652636024',
      '1602844590651',
      '1602846142569',
      '1602843342118',
      '1602847062972'].includes(this.getUserInfo().origanization) || this.getCurrentPublicMode() === 'development') {
      schoolPaperCardMenu = {
        menuId: '4004',
        menuText: '组卷题卡',
        iconClassName: 'el-icon-edit-outline',
        url: '',
        target: '',
        children: [
          {
            Pid: '4004',
            menuId: '40041',
            menuText: '在线组卷',
            iconClassName: 'iconfont icon-tiqiatiku',
            url: `/paper/${this.getUserInfo().userId}/${this.getUserInfo().origanization}/add/knowledge-point/0`,
            target: 'blank',
            children: []
          },
          {
            Pid: '4004',
            menuId: '40042',
            menuText: '我的卷库',
            iconClassName: 'iconfont icon-yonghu3',
            url: `/paper/${this.getUserInfo().userId}/${this.getUserInfo().origanization}/list/UserPaperList`,
            target: '',
            children: []
          },
          {
            Pid: '4004',
            menuId: '40043',
            menuText: '在线题卡',
            iconClassName: 'iconfont icon-datiqia1',
            url: '/card/list',
            target: '',
            children: []
          }
        ]
      }
    }
    // 学校信息管理员
    userMenus.set(this.systemRoleEnum.schoolInfoManager, [{
      menuId: '4001',
      menuText: '考试',
      iconClassName: 'iconfont icon-kaoshi',
      url: '/',
      target: '',
      children: []
    },
    {
      menuId: '4002',
      menuText: '成绩',
      iconClassName: 'iconfont icon-chengji',
      url: `/score/list/${this.getUserInfo().origanization}`,
      target: '',
      children: []
    },
    {
      menuId: '4003',
      menuText: '学校信息',
      iconClassName: 'iconfont icon-jichuxinxi1',
      url: '',
      target: '',
      children: [
        {
          Pid: '4003',
          menuId: '40031',
          menuText: '我校信息',
          iconClassName: 'iconfont icon-kehuguanli',
          url: `/org/${this.getUserInfo().origanization}/school-info`,
          target: '',
          children: []
        },
        {
          Pid: '4003',
          menuId: '40032',
          menuText: '教师',
          iconClassName: 'iconfont icon-laoshi',
          url: '/teacher/manage',
          target: '',
          children: []
        },
        {
          Pid: '4003',
          menuId: '40033',
          menuText: '学生',
          iconClassName: 'iconfont icon-xuesheng',
          url: '/student',
          target: '',
          children: []
        },
        {
          Pid: '4003',
          menuId: '40034',
          menuText: '教学班',
          iconClassName: 'iconfont icon-xuesheng',
          url: '/class/teaching',
          target: '',
          children: []
        },
        {
          Pid: '4003',
          menuId: '40035',
          menuText: '行政班',
          iconClassName: 'iconfont icon-xuesheng',
          url: '/class/admin',
          target: '',
          children: []
        }
      ]
    }
    // schoolPaperCardMenu
    ])

    // 学校教师
    userMenus.set(this.systemRoleEnum.teacher, [{
      menuId: '7001',
      menuText: '考试',
      iconClassName: 'iconfont icon-kaoshi',
      url: '/',
      target: '',
      children: []
    },
    {
      menuId: '7002',
      menuText: '成绩',
      iconClassName: 'iconfont icon-chengji',
      url: `/score/list/${this.getUserInfo().origanization}`,
      target: '',
      children: []
    }])
    // 代理商
    userMenus.set(this.systemRoleEnum.agent, [
    // {
    //   menuId: '10001',
    //   menuText: '首页',
    //   iconClassName: 'iconfont icon-shouye',
    //   url: '/',
    //   target: '',
    //   children: []
    // },
      {
        menuId: '10002',
        menuText: '客户',
        iconClassName: 'iconfont icon-kehu',
        url: '/agent-customer',
        target: '',
        children: []
      }, {
        menuId: '10003',
        menuText: '监控',
        iconClassName: 'iconfont icon-xitongjiankong',
        url: '/admin/exam-list-unrelease',
        target: '',
        children: []
      }])
    return userMenus.get(roldId.toString())
  },
  getPostionNameByCode (positionCode) {
    switch (positionCode) {
      case '0':
        return '校长'
      case '1':
        return '年级备课组长'
      case '2':
        return '年级组长'
      case '3':
        return '班主任'
      case '4':
        return '任课教师'
    }
  },
  /**
 * 处理进度值
 *     (0, 0.01]    ----> 0.01
 *     (0.01, 0.99] ----> 四舍五入，保留两位小数
 *     (0.99, 1)    ----> 0.99
 * @author wangk 2018-12-10T13:57:39+0800
 * @param  {Number} progress 扫描/评卷进度值, 0 - 1 之间
 * @return {Number}
 */
  processProgressValue (value) {
    let val = value
    if (val < 0) {
      console.warn('error', 'scan progress less than 0%')
    } else if (val === 0) {
      val = 0
    } else if (val <= 0.01) {
      val = 0.01
    } else if (val <= 0.99) {
      val = parseFloat(val.toFixed(2), 10)
    } else if (val < 1) {
      val = 0.99
    }
    return val
  },
  // 转换协议头
  convertUrlProtocol (url) {
    let protocol = window.location.protocol
    let urlProtocol = url.substr(0, url.indexOf(':') + 1)
    if (urlProtocol !== protocol) {
      url = url.replace(urlProtocol, protocol)
    }
    return url
  },
  /**
 * 下载文件
 * @author changh 2021-03-10T13:57:39+0800
 * @param  {Number} url 下载文件链接
 * @return {Number}
 */
  downloadFile (url) {
    let iframe = document.createElement('iframe')
    url = this.convertUrlProtocol(url)
    iframe.setAttribute('src', url)
    document.body.appendChild(iframe)
    setTimeout(() => {
      iframe.remove()
    }, 2 * 60 * 1000)
  },
  byteCode (codes) {
    let codeStr = ''
    let binStr
    for (let i = 0; i < codes.length; i += 2) {
      binStr = parseInt(codes.slice(i, i + 2), 16).toString(2)
      if (binStr.length < 8) {
        binStr = ('0000000' + binStr).slice(-8)
      }
      codeStr += binStr
    }
    return codeStr
  },
  charToUtf8 (text) {
    let index = 0
    let output = ''
    while (index < text.length) {
      let character = text.charAt(index)
      let charCode = text.charCodeAt(index)
      if (charCode >= 0xD800 && charCode <= 0xDBFF) {
        output += encodeURI(character + text.charAt(++index)).replace(/%/g, '')
      } else {
        if (charCode > 127) { output += encodeURI(character).replace(/%/g, '') } else {
          let asc = charCode.toString(16).toUpperCase()
          if (asc.length < 2) asc = '0' + asc
          output += asc
        }
      }
      ++index
    }
    return output
  },
  base64urlEncode  (str) {
    let base64Chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-/'.split('')
    let bb = this.byteCode(this.charToUtf8(str))
    let b6 = []
    let base64 = ''
    let n
    for (let i = 0; i < bb.length; i += 6) {
      b6.push(bb.slice(i, i + 6))
    }
    for (let x in b6) {
      if (Number(x) + 1 === b6.length) {
        b6[x] = (b6[x] + '00000').slice(0, 6)
      }
      base64 += base64Chars[parseInt(b6[x], 2)]
    }
    if (bb.length % 24 !== 0) {
      n = (24 - bb.length % 24) / 8
      if (n === 1) base64 += '='
      else if (n === 2) {
        base64 += '=='
      }
    }
    return base64
  },
  /**
   * 系统角色枚举
   */
  systemRoleEnum: {
    // 系统管理员
    admin: '1',
    // 教育局信息管理员
    eduInfoManager: '2',
    // 教研员
    researcher: '3',
    // 学校信息管理员
    schoolInfoManager: '4',
    // 学校科目备课组长
    schoolSubjectLeader: '5',
    // 评卷教师
    teacher: '7',
    // 学生家长
    studentParent: '6',
    // 代理商
    agent: '10'
  },

  /**
   * 学校职位枚举
   */
  schoolJobEnum: {
    // 校长
    schoolmaster: '0',
    // 备课组长
    LeaderOfLessonPreparation: '1',
    // 年级组长
    LeaderOfGrade: '2',
    // 班主任
    classmaster: '3',
    // 教师
    teacher: '4'
  },
  // 年级 ID 和 年级名映射表
  gradeNameMap: {
    '1': '小一',
    '2': '小二',
    '3': '小三',
    '4': '小四',
    '5': '小五',
    '6': '小六',
    '7': '初一',
    '8': '初二',
    '9': '初三',
    '10': '高一',
    '11': '高二',
    '12': '高三'
  },
  // 其实这里应该叫 examLevel,
  // 但是由于以前一直是这么用的, 所以保留原名称
  examTypeMap: {
    '11': '局',
    '12': '局',
    '21': '校'
  },
  examTypeKey: {
    'eduCity': '11',
    'eduArea': '12',
    'school': '21'
  },
  // 其实这里应该叫 examType,
  // 但是由于 examType 之前被占了, 只能退而求其次
  examTagMap: {
    'weekly-exam': '周考',
    'monthly-exam': '月考',
    'mock-exam': '模拟',
    'mid-term-exam': '期中',
    'final-exam': '期末',
    'other-exam': '其他',
    '3+1+2': '新3+1+2',
    '3+3': '新3+3',
    'teaching-exam': '新选考'
  },
  newGKTypes: ['3+1+2', '3+3', 'teaching-exam'],
  newGKTypesStrict: ['3+1+2', '3+3'],
  // 用户的关键操作行为
  userBehaviors: [
    { type: 'ALL', name: '全部' },
    { type: 'LOGIN', name: '登入' },
    { type: 'LOGOUT', name: '登出' },
    { type: 'DEL_EXAM', name: '删除考试' },
    { type: 'RESET_PASSWORD', name: '修改密码' },
    { type: 'CREATE_EXAM', name: '创建考试' },
    { type: 'REMARK', name: '重评' },
    { type: 'CALC_SCORE', name: '出成绩' }
  ],
  // 任务类型枚举
  readTaskType: {
    normal: 'normal',
    problem: 'problem',
    rescore: 'rescore',
    final: 'final'
  },
  // 键盘给分编号
  scoreKeyCodes: [
    8, 27, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 110, 116, 108, 144, 190
  ],
  // 题目类型枚举
  itemTypes: {
    xuanZeDan: '1',
    tianKong: '2',
    xuanZeDuo: '3',
    panDuan: '4',
    jieSuan: '5',
    yingYong: '6',
    caoZuo: '7',
    zuoWen: '',
    jieDa: '9'
  },
  // 题卡类型枚举
  paperTypes: {
    // 手阅
    handwork: '2',
    // 在线题卡
    online: '1',
    // 普通线下模版卡
    offline: '0'
  },
  /**
   * 获取一个跟当前时间相关的不重复的数字,当你需要一个不重复的字符串时可以用它
   * @author changh 2018-02-18T10:25:12+0800
   * @return {string} timeKey
   */
  checkFinish (obj) {
    return obj.status && obj.status === '已完成' ? 1 : 0
  },
  // 获取当前网络协议配置
  getCurrentProtocol () {
    return window.location.protocol
  },
  // 获取当前打包模式
  getCurrentPublicMode () {
    return HostConfig.publicMode
  },
  // 拼接评卷单元地址
  createPJUnitUrl (examId, subjectId, itemId) {
    if (itemId) {
      return `${this.getCurrentProtocol()}//${window.location.host}/PJService/action/pjunit/${examId}/${subjectId}/${itemId}`
    } else {
      return `${this.getCurrentProtocol()}//${window.location.host}/PJService/action/pjexam/${examId}/${subjectId}`
    }
  },
  // 创建复制区，可以黏贴文字
  createCopyText (elementId) {
    try {
      let text = document.getElementById(elementId)
      let selection = window.getSelection()
      let range = document.createRange()
      range.selectNodeContents(text)
      selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand('Copy', 'false', null)
      selection.removeRange(range)
    } catch (ex) {
      console.log(ex)
      return false
    }
    return true
  },
  // 日期格式化
  parseTime (time, pattern) {
    if (arguments.length === 0 || !time) {
      return null
    }
    const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
        time = parseInt(time)
      } else if (typeof time === 'string') {
        time = time.replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');""
      }
      if (typeof time === 'number' && time.toString().length === 10) {
        time = time * 1000
      }
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key]
      // Note: getDay() returns 0 on Sunday
      if (key === 'a') {
        return ['日', '一', '二', '三', '四', '五', '六'][value]
      }
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    return timeStr
  },
  download (name, isDelete = true, replaceName) {
    var url = `/kwTool/common/download?fileName=` + encodeURI(name) + `&delete=` + isDelete
    return axios({
      method: 'get',
      url: url,
      responseType: 'blob',
      headers: { 'Authorization': 'Bearer ' + this.getToken() },
      timeout: 30 * 60 * 1000
    }).then(async (res) => {
      const isLogin = await this.blobValidate(res.data)
      if (isLogin) {
        const blob = new Blob([res.data])
        if (replaceName) {
          this.saveAs(blob, replaceName)
        } else {
          this.saveAs(blob, name)
        }
      } else {
        Message.error('无效的会话，或者会话已过期，请重新登录。')
      }
    })
  },
  saveAs (text, name, opts) {
    saveAs(text, name, opts)
  },
  async blobValidate (data) {
    try {
      const text = await data.text()
      JSON.parse(text)
      return false
    } catch (error) {
      return true
    }
  },
  // 确保 URL 的协议与当前访问地址一致
  adjustURLProtocol (url) {
    // 获取当前页面的协议 (http 或 https)
    const currentProtocol = window.location.protocol

    // 创建一个新的 URL 对象
    const urlObj = new URL(url)

    // 如果 URL 的协议和当前页面的协议不同，调整为当前协议
    if (urlObj.protocol !== currentProtocol) {
      // 修改协议部分
      urlObj.protocol = currentProtocol
    }

    // 返回修改后的 URL
    return urlObj.toString()
  }

}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj (url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}



// WEBPACK FOOTER //
// ./src/util/common.js